export class EmbeddedToken {

  public expiration: string;
  public token: string;
  public tokenId: string;

  static fromDto(d: any): EmbeddedToken {
    if (!d) {
      return null;
    }

    const embeddedToken = new EmbeddedToken();

    embeddedToken.expiration = d.expiration;
    embeddedToken.token = d.token;
    embeddedToken.tokenId = d.embedUrl;

    return embeddedToken;
  }

  static toDto(embeddedToken: EmbeddedToken): any {
    if (!embeddedToken) {
      return null;
    }

    return {
      expiration: embeddedToken.expiration,
      token: embeddedToken.token,
      tokenId: embeddedToken.tokenId,
    };
  }
}
